<template>
  <div class="footer">
    <div style="max-width: 1468px; margin: 0px auto">
      <!-- <p>{{ formOrgInfo.formName }}</p> -->
      <!-- <p>备案许可证：湘ICP备18008295号&nbsp;&nbsp;湘公网安备43010302002144号 &nbsp;技术支持：上海上业信息科技股份有限公司</p> -->
      <p>版权所有：武汉市少年儿童图书馆 鄂ICP备05013209号-1 鄂公网安备 42010202000925号 地址：武汉市江岸区南京路86号 电话：（027）82773406</p>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      formOrgInfo:''
    }
  },
  created(){
    // let formOrg = this.$cookie.getCookie('formOrg')
    // if(formOrg){
    //   this.formOrgInfo = formOrg
    // }
  }
};
</script>

<style lang="less" scoped>
@import "/src/css/base.css";
// 底部
.footer{
  height: 56px;
  background-color: #313131 !important;
  font-size: 14px;
  color: #fff;
  line-height: 56px;
  text-align: center;
  // padding: 20px 0px;
  // box-sizing: border-box;
}
</style>